import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=e347f51e&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e347f51e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e347f51e')) {
      api.createRecord('e347f51e', component.options)
    } else {
      api.reload('e347f51e', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=e347f51e&scoped=true&", function () {
      api.rerender('e347f51e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2XmXlExkjPaSs/JS/comp/Accordion.vue"
export default component.exports